export default "__VITE_ASSET__Dx7Zb3jh__"